export default __webpack_public_path__ + "78371ac5a237199215a2c1d798582d55.svg";